import { useState } from "react";
import CreatePost from "../../components/community/components/post/CreatePost";
import PostFeed from "../../components/community/components/post/PostFeed";
import EditPostModal from "../../components/community/components/post/components/EditPostModal";
import DeletePostDialog from "../../components/community/components/post/components/DeletePostDialog";
import StoryTrayContainer from "../../components/community/components/stories/StoryTrayContainer";
import { CommunityPost } from "../../services/post.api";

export default function Community() {
  const [editingPost, setEditingPost] = useState<CommunityPost | null>(null);
  const [deletingPost, setDeletingPost] = useState<CommunityPost | null>(null);

  return (
    <>
      <div className="mb-3">
        <CreatePost />
      </div>

      <div className="mb-3">
          <StoryTrayContainer />

      </div>

      <PostFeed
        onEdit={(post) => setEditingPost(post)}
        onDelete={(post) => setDeletingPost(post)}
      />

      <EditPostModal
        post={editingPost}
        isOpen={!!editingPost}
        onClose={() => setEditingPost(null)}
      />

      <DeletePostDialog
        post={deletingPost}
        isOpen={!!deletingPost}
        onClose={() => setDeletingPost(null)}
      />
    </>
  );
}
